import { render, staticRenderFns } from "./service-requests.vue?vue&type=template&id=0d2ea7fa"
import script from "./service-requests.vue?vue&type=script&lang=js"
export * from "./service-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports